export function getNavigatorConnectionData() {
    // navigator.connection is not supported on all browsers
    // https://caniuse.com/?search=navigator.connection
    // it would still have value wherever its supported
    const data = window.navigator.connection;
    return {
        downlink: data === null || data === void 0 ? void 0 : data.downlink,
        effectiveType: data === null || data === void 0 ? void 0 : data.effectiveType,
        rtt: data === null || data === void 0 ? void 0 : data.rtt,
        saveData: data === null || data === void 0 ? void 0 : data.saveData,
    };
}
//# sourceMappingURL=getNavigatorConnectionData.js.map